var _ISetMappedClass_set, _ISetMappedClass_toKey, _ISetMappedClass_fromKey;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { objectIs } from '../others';
export const ISetMapped = {
    new: (iterable, toKey, fromKey) => new ISetMappedClass(iterable, toKey, fromKey),
    equal: (a, b) => {
        if (a.size !== b.size)
            return false;
        return a.every((e) => b.has(e));
    },
    diff: (oldSet, newSet) => ({
        deleted: oldSet.subtract(newSet),
        added: newSet.subtract(oldSet),
    }),
    intersection: (a, b) => a.intersect(b),
    union: (a, b) => a.union(b),
};
class ISetMappedClass {
    constructor(iterable, toKey, fromKey) {
        _ISetMappedClass_set.set(this, void 0);
        _ISetMappedClass_toKey.set(this, void 0);
        _ISetMappedClass_fromKey.set(this, void 0);
        // eslint-disable-next-line no-restricted-globals
        __classPrivateFieldSet(this, _ISetMappedClass_set, new Set(Array.from(iterable, toKey)), "f");
        __classPrivateFieldSet(this, _ISetMappedClass_toKey, toKey, "f");
        __classPrivateFieldSet(this, _ISetMappedClass_fromKey, fromKey, "f");
    }
    get size() {
        return __classPrivateFieldGet(this, _ISetMappedClass_set, "f").size;
    }
    get isEmpty() {
        return this.size === 0;
    }
    has(key) {
        return __classPrivateFieldGet(this, _ISetMappedClass_set, "f").has(__classPrivateFieldGet(this, _ISetMappedClass_toKey, "f").call(this, key));
    }
    every(predicate) {
        for (const key of this.values()) {
            if (!predicate(key))
                return false;
        }
        return true;
    }
    some(predicate) {
        for (const key of this.values()) {
            if (predicate(key))
                return true;
        }
        return false;
    }
    add(key) {
        if (this.has(key))
            return this;
        return ISetMapped.new([...__classPrivateFieldGet(this, _ISetMappedClass_set, "f"), __classPrivateFieldGet(this, _ISetMappedClass_toKey, "f").call(this, key)].map(__classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f")), __classPrivateFieldGet(this, _ISetMappedClass_toKey, "f"), __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f"));
    }
    delete(key) {
        if (!this.has(key))
            return this;
        const keyMapped = __classPrivateFieldGet(this, _ISetMappedClass_toKey, "f").call(this, key);
        return ISetMapped.new(
        // eslint-disable-next-line no-restricted-globals
        Array.from(__classPrivateFieldGet(this, _ISetMappedClass_set, "f"))
            .filter((k) => !objectIs(k, keyMapped))
            .map(__classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f")), __classPrivateFieldGet(this, _ISetMappedClass_toKey, "f"), __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f"));
    }
    withMutations(actions) {
        // eslint-disable-next-line no-restricted-globals
        const result = new Set(__classPrivateFieldGet(this, _ISetMappedClass_set, "f"));
        for (const action of actions) {
            const key = __classPrivateFieldGet(this, _ISetMappedClass_toKey, "f").call(this, action.key);
            switch (action.type) {
                case 'delete':
                    result.delete(key);
                    break;
                case 'add':
                    result.add(key);
                    break;
            }
        }
        return ISetMapped.new(
        // eslint-disable-next-line no-restricted-globals
        Array.from(result, __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f")), __classPrivateFieldGet(this, _ISetMappedClass_toKey, "f"), __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f"));
    }
    map(mapFn) {
        return ISetMapped.new(this.toArray().map(mapFn), __classPrivateFieldGet(this, _ISetMappedClass_toKey, "f"), __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f"));
    }
    filter(predicate) {
        return ISetMapped.new(this.toArray().filter(predicate), __classPrivateFieldGet(this, _ISetMappedClass_toKey, "f"), __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f"));
    }
    filterNot(predicate) {
        return ISetMapped.new(this.toArray().filter((k) => !predicate(k)), __classPrivateFieldGet(this, _ISetMappedClass_toKey, "f"), __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f"));
    }
    forEach(callbackfn) {
        for (const km of __classPrivateFieldGet(this, _ISetMappedClass_set, "f")) {
            callbackfn(__classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f").call(this, km));
        }
    }
    isSubsetOf(set) {
        return this.every((k) => set.has(k));
    }
    isSupersetOf(set) {
        return set.every((k) => this.has(k));
    }
    subtract(set) {
        return ISetMapped.new(this.toArray().filter((k) => !set.has(k)), __classPrivateFieldGet(this, _ISetMappedClass_toKey, "f"), __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f"));
    }
    intersect(set) {
        return ISetMapped.new(this.toArray().filter((k) => set.has(k)), __classPrivateFieldGet(this, _ISetMappedClass_toKey, "f"), __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f"));
    }
    union(set) {
        return ISetMapped.new([...this.values(), ...set.values()], __classPrivateFieldGet(this, _ISetMappedClass_toKey, "f"), __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f"));
    }
    *[(_ISetMappedClass_set = new WeakMap(), _ISetMappedClass_toKey = new WeakMap(), _ISetMappedClass_fromKey = new WeakMap(), Symbol.iterator)]() {
        for (const k of this.keys()) {
            yield k;
        }
    }
    *keys() {
        for (const km of __classPrivateFieldGet(this, _ISetMappedClass_set, "f").keys()) {
            yield __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f").call(this, km);
        }
    }
    *values() {
        for (const km of __classPrivateFieldGet(this, _ISetMappedClass_set, "f").keys()) {
            yield __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f").call(this, km);
        }
    }
    *entries() {
        for (const km of __classPrivateFieldGet(this, _ISetMappedClass_set, "f").keys()) {
            const a = __classPrivateFieldGet(this, _ISetMappedClass_fromKey, "f").call(this, km);
            yield [a, a];
        }
    }
    toArray() {
        // eslint-disable-next-line no-restricted-globals
        return Array.from(this.values());
    }
    toRawSet() {
        return __classPrivateFieldGet(this, _ISetMappedClass_set, "f");
    }
}
